import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";

export const composeEditorExtensions = [
  StarterKit,
  Link.configure({ openOnClick: true }),
  Image.configure({
    inline: true,
    allowBase64: true,
  }),
];

export function safeSetEditorHtml(editor, html) {
  if (!editor || editor.isDestroyed) return;
  const content = html || "<p></p>";
  try {
    editor.commands.setContent(content, false);
  } catch (err) {
    console.warn("TipTap setContent:", err);
    try {
      if (!editor.isDestroyed) {
        editor.commands.setContent("<p></p>", false);
      }
    } catch {
      /* ignore */
    }
  }
}
